import { makeStyles } from "@material-ui/core";

export const filtersStyles = makeStyles((theme) => ({
  closeButton: {
    color: "black",
    paddingRight: "2px",
    right: "-5px",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  filterContaier: {
    paddingTop: "15px",
    "& .MuiFormControl-marginNormal": {
      margin: "0px",
    },
    "& .MuiInputBase-formControl": {
      margin: "0px",
      height: "48px",
      backgroundColor: "white",
      "& .MuiSelect-select": {
        fontFamily: "Inter",
        color: "#000000",
        fontWeight: "400",
        fontSize: theme.typography.pxToRem(16),
        backgroundColor: "transparent",
      },
    },
  },
  input: {
    "&::placeholder": {
      color: "black",
    },
  },
}));
